module.exports = __webpack_public_path__ + "media/images/michael_australia-3623f0a772133f4ce6a03dc1c5e9c004.png";